<template>
  <div v-if="open" class="modal-backdrop" @click.self="$emit('cancel')">
    <div class="modal-card" role="dialog" aria-modal="true" :aria-labelledby="titleId">
      <h2 :id="titleId" class="modal-title">Delete group</h2>
      <p class="modal-body">
        Are you sure you want to delete the group <strong>"{{ groupName }}"</strong>?
        <br />
        The group contains <strong>{{ memberCount }} {{ kindLabel }}</strong>.
      </p>
      <div class="modal-actions">
        <button type="button" class="btn btn--secondary" @click="$emit('cancel')">Cancel</button>
        <button type="button" class="btn btn--danger" @click="$emit('confirm')">Delete</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  open: { type: Boolean, default: false },
  groupName: { type: String, default: '' },
  memberCount: { type: Number, default: 0 },
  kind: { type: String, default: 'roiProcess' },
});
defineEmits(['confirm', 'cancel']);

const titleId = `delete-group-modal-${Math.random().toString(36).slice(2)}`;
const kindLabel = computed(() => (props.kind === 'roiQueue' ? 'queues' : 'processes'));
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 1.5rem 1.75rem;
  width: min(440px, 90vw);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18);
}

.modal-title {
  margin: 0 0 0.75rem;
  font-size: 1.125rem;
  color: #0f172a;
}

.modal-body {
  margin: 0 0 1.25rem;
  color: #334155;
  line-height: 1.5;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.btn {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
}

.btn--secondary {
  background: #f1f5f9;
  color: #334155;
  border-color: #cbd5e1;
}

.btn--secondary:hover {
  background: #e2e8f0;
}

.btn--danger {
  background: #dc2626;
  color: #ffffff;
}

.btn--danger:hover {
  background: #b91c1c;
}
</style>
